import { useOfferListQuery } from '@graphql/queries/__generated__/offer-list.generated'
import makeStyles from '@mui/styles/makeStyles'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { SwiperOptions } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { maybe } from '../../../utils/misc'

const useStyles = makeStyles(theme => ({
  slide: {
    borderRight: '1px solid #d8d8d8',
    margin: '10px 0',
    '&:last-of-type': {
      borderRightColor: 'transparent',
    },
  },
}))

const OffersSkeleton = () => {
  return <div className='h-60' />
}

interface OfferListProps {}

const OfferList: React.FC<OfferListProps> = ({}) => {
  const classes = useStyles()
  const offerListQuery = useOfferListQuery({
    variables: { first: 10 },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  const swiperOptions: SwiperOptions = {
    spaceBetween: 0,
    slidesPerView: 4,
    lazy: true,
    preloadImages: false,
    centerInsufficientSlides: true,
    pagination: {
      clickable: true,
      el: `#swiper-pagination-offer`,
    },
    autoplay: {
      disableOnInteraction: false,
      delay: 5000,
      waitForTransition: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        speed: 300,
      },
      500: {
        slidesPerView: 2,
        speed: 300,
      },
      700: {
        slidesPerView: 3,
        speed: 500,
      },
      1000: {
        slidesPerView: 5,
        speed: 1000,
      },
    },
    watchSlidesProgress: true,
    // allowSlideNext: false,
    // allowSlidePrev: false,
    loop: false,
  }
  const offers = useMemo(
    () => maybe(() => offerListQuery.data.offerList.edges.map(edge => edge.node), []),
    [offerListQuery.data]
  )
  if (!offers.length && !offerListQuery.loading) return null
  return (
    <>
      {!offers.length && offerListQuery.loading && <OffersSkeleton />}
      {offers.length > 0 && (
        <>
          <Swiper {...swiperOptions}>
            {offers.map(node => {
              const pathname = new URL(node.url).pathname
              return (
                <SwiperSlide key={node.id} className={classes.slide}>
                  <div className={`text-center h-40 flex items-center justify-center py-5 px-10`}>
                    <Link to={pathname} className='no-underline line-clamp-2' target='_blank'>
                      {node.name}
                    </Link>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div
            id={`swiper-pagination-offer`}
            className={`swiper-pagination swiper-pagination-clickable swiper-pagination-bullets w-full ${
              offers.length > 1 ? 'block' : 'hidden'
            } ${offers.length > 4 ? '' : 'md:hidden'}`}
          />
        </>
      )}
    </>
  )
}

export default OfferList
